var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex space-x-4"},[_c('div',{class:[
        _vm.calculateScoreClass(_vm.data.lighthouse_performance_score),
        'border-2',
        'p-2',
        'rounded-lg'
    ]},[_vm._v("\n        "+_vm._s(_vm.data.lighthouse_performance_score)+"\n        "),_vm._m(0)]),_vm._v(" "),_c('div',{class:[
        _vm.calculateScoreClass(_vm.data.lighthouse_accessibility_score),
        'border-2',
        'p-2',
        'rounded-lg'
    ]},[_vm._v("\n        "+_vm._s(_vm.data.lighthouse_accessibility_score)+"\n        "),_vm._m(1)]),_vm._v(" "),_c('div',{class:[
        _vm.calculateScoreClass(_vm.data.lighthouse_best_practices_score),
        'border-2',
        'p-2',
        'rounded-lg'
    ]},[_vm._v("\n        "+_vm._s(_vm.data.lighthouse_best_practices_score)+"\n        "),_vm._m(2)]),_vm._v(" "),_c('div',{class:[
        _vm.calculateScoreClass(_vm.data.lighthouse_seo_score),
        'border-2',
        'p-2',
        'rounded-lg'
    ]},[_vm._v("\n        "+_vm._s(_vm.data.lighthouse_seo_score)+"\n        "),_vm._m(3)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('small',[_vm._v("Performance")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('small',[_vm._v("Accessibility")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('small',[_vm._v("Best Practices")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-red"},[_c('small',[_vm._v("SEO")])])
}]

export { render, staticRenderFns }